module.exports = __webpack_public_path__ + "img/no-catalog.5b3894e2.svg";